import { createContext, useState } from 'react'

export const LocaleContext = createContext({
  locale: 'en',
  setLocale: () => {
    null
  }
})

const CACHE_KEY = 'locale'

const LocaleProvider = ({ children }) => {
  const currentLocale = localStorage.getItem(CACHE_KEY)

  const [locale, setLang] = useState(() => {
    return JSON.parse(currentLocale) || 'en'
  })

  const setLocale = state => {
    setLang(() => {
      localStorage.setItem(CACHE_KEY, JSON.stringify(state))
      return state
    })
  }

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  )
}

export default LocaleProvider
